<div id="bar_chart"
  *ngIf="barData"
  [chartData]="barData"
  [chartOptions] = "barOptions"
  [selectionCallback] = "selectionCallback"
  chartType="ColumnChart"
  GoogleChart
  class="content-box"></div>